export default __webpack_public_path__ + "static/media/map-icon.5fb1efe1.svg";